import { InputLabel, MenuItem, Modal, Select, Stack } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import pxToRem from '../../../helpers/pxToRem'
import { useMemo, useState } from 'react'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import {
    addTeacherEmploymentSetting,
    updateECCAccreditationLevel,
} from '../../../firebase/teacherApi'
import { TeacherRegFormControl } from '../../../components/FormControl'
import { ECCAccreditationLevel } from '../../../firebase/types-teacher'
import { setErrorMsg } from '../../../redux/uiSlice'
import { TeacherEmploymentSetting } from '../../../redux/types'

const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: pxToRem(500),
    height: '90%',
    maxHeight: pxToRem(400),
    backgroundColor: '#fff',
    boxShadow: '0px 4px 4px 0px #00000040',
    borderRadius: pxToRem(16),
}

const EducatorLevelModal = () => {
    const dispatch = useDispatch()
    const userId = useSelector((state: RootState) => state.user.auth.status?.uid)
    const accountState = useSelector(
        (state: RootState) => state.userReg.fields.accountState?.value
    )
    const employmentSetting = useSelector(
        (state: RootState) => state.userReg.employmentSetting
    )
    const empSettingNode = useSelector(
        (state: RootState) => state.userReg.fields.employmentSetting
    )

    const [loading, setLoading] = useState(false)

    const showModal = useMemo(
        () =>
            ['earlyChildcare', 'both'].includes(
                employmentSetting?.type as TeacherEmploymentSetting
            ) && !employmentSetting?.level,
        [employmentSetting]
    )

    const handleChange = async (
        level: ECCAccreditationLevel,
        locationState: string
    ) => {
        try {
            setLoading(true)
            if (!userId) throw new Error('User not authenticated.')
            const settings = Object.entries(empSettingNode || {}).find(
                ([key, val]) =>
                    val.type === 'earlyChildcare' &&
                    val.locationState === locationState
            )
            if (settings) {
                const res = await updateECCAccreditationLevel(
                    userId,
                    settings[0],
                    level
                )
                if (res.code !== 200) throw res.error
            } else {
                // setting doesn't exist, add new employment setting
                const res = await addTeacherEmploymentSetting(
                    userId,
                    'earlyChildcare',
                    locationState,
                    level
                )
                if (res.code !== 200) throw res.error
            }
        } catch (error) {
            dispatch(
                setErrorMsg(
                    error instanceof Error
                        ? error.message
                        : JSON.stringify(error)
                )
            )
        } finally {
            setLoading(false)
        }
    }

    if (
        ['approved', 'onHold'].includes(accountState as string) ||
        !employmentSetting
    ) {
        return <></>
    }

    return (
        <>
            <Modal open={showModal}>
                <Stack
                    style={{
                        ...modalStyle,
                        height: 'fit-content',
                        maxHeight: '90%',
                    }}
                    sx={{ padding: pxToRem(40), gap: pxToRem(20) }}
                >
                    <h3 style={{ margin: 0 }}>
                        Select your Early Childhood Accreditation Level:
                    </h3>
                    {loading ? (
                        <Stack height="100%" width="100%">
                            <LoadingSpinner />
                        </Stack>
                    ) : (
                        <>
                            <TeacherRegFormControl
                                variant="standard"
                                sx={{ width: '500px', maxWidth: '100%' }}
                            >
                                <InputLabel>
                                    Early Childhood Accreditation Level:
                                </InputLabel>
                                <Select
                                    value={''}
                                    label={
                                        'Early Childhood Accreditation Level:'
                                    }
                                    onChange={(e) =>
                                        handleChange(
                                            e.target
                                                .value as ECCAccreditationLevel,
                                            employmentSetting.locationState
                                        )
                                    }
                                >
                                    <MenuItem disabled value="">
                                        <em>Select your level here...</em>
                                    </MenuItem>
                                    {/* <MenuItem value={'educator'}>Educator</MenuItem> */}
                                    <MenuItem value={'certIII'}>
                                        Cert III
                                    </MenuItem>
                                    <MenuItem value={'diploma'}>
                                        Diploma
                                    </MenuItem>
                                    <MenuItem value={'earlyChildhoodTrained'}>
                                        ECT
                                    </MenuItem>
                                </Select>
                            </TeacherRegFormControl>
                        </>
                    )}
                </Stack>
            </Modal>
        </>
    )
}

export default EducatorLevelModal
